function showFilter() {
  $("#filterContainer").show();
  $("#schedule-view-switch").removeClass("sticky-top");
  $("#schedule-view-switch p").hide();
  if (typeof $("#filterHelpText") !== "undefined") {
    $("#filterHelpText").show();
  }
}

function hideFilter() {
  $("#filterContainer").hide();
  $("#schedule-view-switch").addClass("sticky-top");
  $("#schedule-view-switch p").show();
  if (typeof $("#filterHelpText") !== "undefined") {
    $("#filterHelpText").hide();
  }
}

$(document).ready(function () {
  const schedule_filters_after_provision_fadein = new CustomEvent(
    "schedule_filters_after_provision_fadein",
  );

  $("#provision").delay(800).fadeIn(500);
  window.dispatchEvent(schedule_filters_after_provision_fadein);

  if (typeof $("#pills-tabContent") !== "undefined") {
    if ($("#pills-calendarview-tab").hasClass("active")) {
      hideFilter();
    }
    if ($("#pills-filmview-tab").hasClass("active")) {
      showFilter();
    }
    $("#pills-filmview-tab").on("click", function () {
      showFilter();
    });
    $("#pills-calendarview-tab").on("click", function () {
      hideFilter();
    });
  }
});
